import React from "react";
import { Link } from "react-router-dom";

function Nav() {
  return (
    <>
      <nav
        className="navbar navbar-expand-lg navbar-light px-5"
        style={{ backgroundColor: "#00000086" }}
      >
        {/* Brand */}
        <Link className="navbar-brand" to="/">
          <img
            src="./assets/images/logo-1.png"
            alt=""
            className="img-fluid d-lg-block d-md-block d-sm-block"
          />
        </Link>
        {/* Mobile Toggler */}
        <button
          className="navbar-toggler collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-expanded="false"
        >
          <span className="navbar-toggler-icon"></span>
          <span className="navbar-toggler-icon"></span>
          <span className="navbar-toggler-icon"></span>
        </button>
        {/* Menu */}
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          {/* Left Menu */}
          <ul className="navbar-nav mr-auto">
            {/* Home */}
            <li className="nav-item active">
              <Link className="nav-link" to="/">
                Home
              </Link>
            </li>
            {/* Services */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="servicesDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Services
              </a>
              <div
                className="dropdown-menu py-2"
                aria-labelledby="servicesDropdown"
              >
                <Link className="dropdown-item" to="/cyber-security-service">
                  Cybersecurity Services
                </Link>
                {/* <div class="dropdown-divider"></div> */}
                {/* <a class="dropdown-item" href="it.php">IT Services</a> */}
              </div>
            </li>
            {/* Solutions */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="solutionsDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Solutions
              </a>
              <div
                className="dropdown-menu py-2"
                aria-labelledby="solutionsDropdown"
              >
                <Link className="dropdown-item" to="/cyber-security-solution">
                  Cybersecurity Solutions
                </Link>
                <div className="dropdown-divider" />
                <Link className="dropdown-item" to="/artificial-intelligence">
                  Artificial Intelligence
                </Link>
              </div>
            </li>
            {/* About */}
            <li className="nav-item">
              <Link className="nav-link" to="/about">
                About
              </Link>
            </li>
            {/* Contact */}
            <li className="nav-item">
              <Link className="nav-link" to="/contact">
                Contact
              </Link>
            </li>
          </ul>
          {/* Right Menu */}
          <ul className="navbar-nav">
            <li className="nav-item">
              <a
                className="nav-link talk_btn"
                href="#"
                data-toggle="modal"
                data-target="#enquiryModal"
              >
                Let’s Talk <i className="fa-solid fa-angle-right" />
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Nav;
